import React from 'react';
import ReactDOM from 'react-dom';
import ErrorBoundary from 'components/ErrorBoundary';
import Root from './root';

//+++++ 热更新 +++++
if (module.hot) { module.hot.accept(); }

ReactDOM.render(
  <ErrorBoundary>
    <Root />
  </ErrorBoundary>,
  document.getElementById('root')
);
